function validate(values) {
  let errors = {};
  if (!values.subject) {
    errors.subject = "Please enter the topic subject.";
  }
  if (!values.message) {
    errors.message = "Please enter at least some kind of message for this topic.";
  }
  return errors;
}

export { validate };
